import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueClipboard from "vue-clipboard2";

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "staging";

Vue.use(VueClipboard);

new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");